import { Button, Form, Input, Modal, Typography } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Dragger from 'antd/es/upload/Dragger';
import Loading from 'components/common/Loading';
import { CustomDatePicker, CustomInput } from 'components/custom';
import CustomDropdown from 'components/dropdown/custom_select';
import dayjs from 'dayjs';
import { useFormik } from 'formik';
import useAuth from 'hooks/useAuth';
import useMember from 'hooks/useMember';
import useNotice from 'hooks/useNotice';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { leave_request_select, PUT } from 'utils';
import NESTEDROUTE from 'utils/router';

type Props = {
  data: any;
};

const MyRequestTab = ({ data }: Props) => {
  const { Text } = Typography;
  const { user } = useAuth();
  const { error } = useNotice();
  const { getAbsenceTypesList } = useMember();
  const [absenceType, setAbsenceType] = useState([{ label: '', value: '' }]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [open, setOpen] = useState(false);

  const showModal = () => {
    setOpen(true);
  };

  const hideModal = (check: Number) => {
    setOpen(false);
    if (check === 1) {
      cancelledRequest('cancelled');
    } else if (check === 2) {
      cancelledRequest('rejected');
    }
  };


  const cancelledRequest = (status: string) => {
    setLoading(true);
    const absenceRequestId = data?.id;
    const url =
      '/api/absence_request/my_managed/' + absenceRequestId + '/approval/';
    PUT(url, { status: status })
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          navigate(NESTEDROUTE.change_request, {
            state: {
              data: data,
              status: status,
              status1: 'request_approved',
            },
          });
        }
      })
      .catch((e) => error('Something went wrong'));
  }
  useEffect(() => {
    setLoading(true);

    getAbsenceTypesList({}).then((res) => {
      setAbsenceType(
        res?.results?.map((o) => {
          return {
            label: o.name,
            value: o.id,
          };
        }),
      );
      setLoading(false);

    });
    // get workdays

  }, []);

  if (loading) return <Loading />;
  return (
    <div style={{ marginTop: '30px' }}>
      {/* {data?.status} */}
      {/*PART1 */}
      <div className={'leave_request_form'}>
        {(user?.id !== data?.user?.id) && (
          <>
            <h1 style={{ fontSize: 20, fontWeight: 700, color: '#000000', marginBottom: 32 }}>
              Who is involved?
            </h1>
            <div style={{ marginBottom: 40 }}>
              <CustomInput
                background="#E4E4E4"
                disabled
                title="Collaborater "
                value={data?.user?.first_name + ' ' + data?.user?.last_name}
              />
            </div>
          </>
        )}
        <h1 style={{ fontSize: 20, fontWeight: 700, color: '#000000', marginBottom: 32 }}>
          When?
        </h1>
        <div style={{ display: 'flex', gap: '80px', width: '100%' }}>
          <div style={{ display: 'flex', gap: '24px', width: '30%' }}>
            <div style={{ width: '50%' }}>
              <CustomDatePicker
                background="#E4E4E4"
                disabled
                title="Start date"
                required
                value={data?.start_date ? dayjs(data?.start_date) : undefined}
              />
            </div>
            <div style={{ width: '50%' }}>
              <CustomDropdown
                disabled
                defaultKey={data?.start_moment}
                options={leave_request_select}
              />
            </div>
          </div>
          <div style={{ display: 'flex', gap: '24px', width: '30%' }}>
            <div style={{ width: '50%' }}>
              <CustomDatePicker
                background="#E4E4E4"
                disabled
                title="End date"
                required
                value={data?.end_date ? dayjs(data?.end_date) : undefined}
              />
            </div>
            <div style={{ width: '50%' }}>
              <CustomDropdown
                disabled
                defaultKey={data?.end_moment}
                options={leave_request_select}
              />
            </div>
          </div>
        </div>
      </div>
      {/*PART 2 */}
      <div style={{ marginTop: '32px' }} className={'leave_request_form'}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h1 style={{ fontWeight: 700, fontSize: 20, color: '#000000' }}>
            Which type(s) of absence do you want to request?
          </h1>
          {/* <button onClick={() => {}} className={'leave_request_form_button'}>
              My balance
            </button> */}
        </div>
        <Text type={'secondary'} style={{ color: '#898989', fontSize: '12px' }}>
          Automatic distribution selects the leave which must be settled as a
          priority
        </Text>

        <div style={{ marginTop: '32px', display: 'flex', gap: '32px' }}>
          <CustomInput
            background="#E4E4E4"
            disabled
            title={'Absence type'}
            width={'464px'}
            value={data?.absence_type?.name}
          />
        </div>
        <div className={'leave_request_form_count'}>
          <p style={{
            marginTop: 50,
            gap: 10,
            color: '#000000',
            fontSize: 16,
            fontWeight: 400
          }}>{data?.working_days}</p>
          <p style={{
            marginTop: 50,
            gap: 10,
            color: '#000000',
            fontSize: 16,
            fontWeight: 500
          }}>days</p>
        </div>

      </div>
      {/*PART 3 */}
      <div style={{ marginTop: '32px' }} className={'leave_request_form'}>
        <h1 style={{ fontWeight: 700, fontSize: 20, color: '#000000' }}>Attach File</h1>
        <div className={'leave_request_form_upload'}>
          <h4 style={{ marginLeft: '32px', color: '#898989', fontSize: 12, fontWeight: 400 }}>
            Accepted File Types * (png, .jpg, .jpeg, .gif, .pdf, .docx / Max
            size: 10 mb)
          </h4>
          <Dragger disabled className={'leave_request_form_upload_form'} style={{ border: '1px solid #E4E4E4', backgroundColor: '#E4E4E4' }}>
            <img alt="upload" src="/icons/upload.svg" />
          </Dragger>
        </div>
      </div>
      {/*PART 4 */}
      <div style={{ marginTop: '32px' }} className={'leave_request_form'}>
        <h1 style={{ fontWeight: 700, fontSize: 20, color: '#000000', marginBottom: 32 }}>Comments</h1>
        <input
          value={data?.comment}
          style={{
            background: '#FFFFFF',
            border: '0.5px solid #73A1E7',
            borderRadius: ' 10px',
          }}
          disabled
          className={'leave_request_form_comment'}
          placeholder="Comment"
        />
      </div>
      <div className={'leave_absence_button_wrapper'} >
        {(data?.status === 'to_be_approved' && (user?.role === 'admin' || user?.role === "department_manager" || user?.role === "service_manager")) ? (
          <div>
            <button
              style={{ background: '#3CD178', fontSize: '16px' }}
              type="submit"
              className={'leave_request_form_submit_button'}
              onClick={() => cancelledRequest('approved')}
            >
              <img src="/icons/submit_icon.svg" alt="submit_icon" />
              APPROVE
            </button>
            <button
              style={{ background: '#F86767', fontSize: '16px' }}
              type="submit"
              className={'leave_request_form_submit_button'}
              onClick={(e) => {
                showModal();
              }}
            >
              <img src="/icons/reject_icon.svg" alt="submit_icon" />
              REJECT
            </button>

          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'row' }} >
            {(data as any)?.status !== 'cancelled' && (data as any)?.status !== 'rejected' && (

              <button
                style={{
                  cursor: dayjs() >= dayjs(data?.start_date) ? 'not-allowed' : 'pointer',
                  color: dayjs() >= dayjs(data?.start_date) ? '#FFF' : '',
                  backgroundColor: dayjs() >= dayjs(data?.start_date) ? '#E4E4E4' : '',
                  width: '228px',
                  fontSize: '16px'
                }}
                onClick={(e) => {
                  showModal();
                }}
                className={'leave_absence_button'}
                disabled={dayjs() >= dayjs(data?.start_date)}
              >
                <img
                  style={{ marginRight: '10px' }}
                  src={dayjs() >= dayjs(data?.start_date) ? "/icons/cancel3.svg" : "/icons/cancel2.svg"}
                  alt="x"
                />
                CANCEL ELEMENT
              </button>
            )}
            <button
              style={{
                cursor: 'pointer',
                marginLeft: '15px',
                fontSize: '16px'
              }}
              onClick={() => navigate(NESTEDROUTE.change_request, {
                state: {
                  data: data,
                  status: 'saved',
                  status1: 'request_approved'
                },
              })}
              className={'leave_absence_button'}
            >
              <img
                style={{ marginRight: '10px' }}
                src="/icons/icon_save_2.svg"
                alt="x"
              />
              SAVE
            </button>
          </div>)}

      </div >
      <div className='request_modal'>
        <Modal
          closeIcon={null}
          title={null}
          footer={null}
          open={open}
          onOk={() => { hideModal(1) }}
          onCancel={() => { hideModal(0) }}
          width={'400px'}
          style={{ top: '40%' }}
        >
          <div style={{ height: '80px' }}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              {data?.status === "to_be_approved" ? (
                <p style={{ color: '#000', fontSize: '14px', marginLeft: -4, marginTop: -8 }}>
                  Are you sure you want to reject this request?
                </p>
              ) : (
                <p style={{ color: '#000', fontSize: '14px', marginLeft: -4, marginTop: -8 }}>
                  Are you sure you want to cancel this request?
                </p>
              )}
              <img
                style={{ marginLeft: '30px', marginTop: -20, marginRight: -4, cursor: 'pointer' }}
                src="/icons/icon_close.svg"
                alt="x"
                onClick={() => hideModal(0)}
              />
            </div>
            <div style={{ height: '20px' }} />
            <div style={{ marginLeft: '172px' }}>
              <Button
                type={'primary'}
                style={{ width: '84px', height: '36px', color: '#000000', backgroundColor: '#FFFFFF', boxShadow: 'none' }}
                onClick={() => hideModal(0)}

              >
                CLOSE
              </Button>
              <Button
                type={'primary'}
                style={{ width: '84px', height: '36px', marginLeft: '12px', color: '#FFFFFF', backgroundColor: '#F86767', boxShadow: 'none' }}
                onClick={() => {
                  if (data?.status === "to_be_approved") {
                    hideModal(2);
                  } else {
                    hideModal(1)
                  }
                }}

              >
                {data?.status === "to_be_approved" ? 'REJECT' : 'CANCEL'}

              </Button>
            </div>
          </div>
        </Modal>
      </div>

    </div>
  );
};

export default MyRequestTab;
